<template>
  <div class="innerItem settingCurrency">
    <div class="currencyList">
      <p class="innerTitle setLabel">{{locale.setting_currency_default}}</p>
      <select class="input" v-model="currency.default">
        <option v-for="item in currency.info" :key="item.c" :value="item.c">{{ `${displayCurrency(item)} - ${item.n}` }}</option>
      </select>
      <div class="mt15">
        <div class="checkbox">
          <input type="checkbox" id="disabled_currency_symbol" v-model="currency.disabledCurrencySymbol">
          <label for="disabled_currency_symbol">통화 표시 노출하지 않음</label>
        </div>
        <div class="mt5"><p class="sysMessage">주문내역에는 통화 표시가 노출됩니다.</p></div>
      </div>
      <div class="mt15">
        <p class="label toCapitalize colorGrey">통화 표시 방법</p>
        <div class="displayCurrency">
          <select class="input inlineInput select" v-model="currency.displayCurrencyType">
            <option value="symbol">기호</option>
            <option value="unit">직접 설정</option>
          </select>
          <div v-if="currency.displayCurrencyType === 'unit'" class="unitInput">
            <SetLanguageValue
              :locale="locale"
              :langValue="currency.displayCurrencyUnit" />
          </div>
        </div>
        <div class="mt5"><p class="sysMessage">{price}: 실제 금액이 대체됩니다. 미입력시 금액만 노출됩니다.</p></div>
      </div>
    </div>
  </div>
</template>

<script>
import SetLanguageValue from '@/components/Util/SetLanguageValue'

export default {
  name: 'SetCurrency',
  props: [
    'locale',
    'currency'
  ],
  components: {
    SetLanguageValue
  },
  methods: {
    displayCurrency (currency) {
      return `${currency.c.toUpperCase()}(${currency.e})`
    }
  }
}
</script>

<style lang="scss" scoped>
.displayCurrency {
  display: flex;
  align-items: center;
}
.unitInput {
  display: inline-block;
  margin-left: 8px;
}
</style>
